export const incomingInvoicesEn = {
  'incomingInvoices.zahlart.label': 'Payment method',
  'incomingInvoices.zahlart.hinweis': 'What was actually used to settle this incoming invoice? Without a selection, the document cannot be marked as paid.',
  'incomingInvoices.zahlart.bitteWaehlen': 'Please select …',
  'incomingInvoices.zahlart.inaktiv': 'inactive',
  'incomingInvoices.zahlart.keineVorhanden': 'No payment method available.',
  'incomingInvoices.zahlart.zurZahlartenpflege': 'Go to payment method settings',
  'incomingInvoices.zahlart.fehlt': 'Please select a payment method.',
  'incomingInvoices.zahlart.bankZuordnungAktiv': 'This invoice is matched to a bank payment. Please remove the match in the payment reconciliation first.',
  'incomingInvoices.zahlart.bezahltMit': 'Paid with: {{name}}',
  'incomingInvoices.zahlart.nichtErfasst': 'Payment method not recorded',
  'incomingInvoices.zahlart.alleBereitsBezahlt': 'All selected documents are already paid or archived.',
};
